<template>
  <div class="agent-dialog">
    <el-dialog title="查看船代" :visible.sync="visible" :before-close="closeDialog" width="720px" :close-on-click-modal="false">
      <div>
        <div style="margin-bottom: 24px;">
          船代信息仅供参考，具体请以订舱口为准！若订舱口船代信息与我们参考船代信息不符，请
          <span @click="toQQ" class="w-blue-1 cursor-pointer">联系客服</span>，谢谢！
        </div>
        <div>
          <WTable :WTableOpts="WTableOpts">
            <template #agent="{ row }">
              <div class="flex" v-if="row.shipStatus == 1">
                <div class="table-content">{{ row.shipAgentName }}</div>
                <!-- <div class="content-center" v-if="row.shipAgent"><i class="iconfont icon-fuzhi" @click="chooseAgent(row.shipAgent)"></i></div> -->
                <div class="content-center" style="margin-left: 8px;" v-if="row.shipAgent">
                  <div class="w-blue-1 cursor-pointer" @click="chooseAgent(row.shipAgent)">选择此船代</div>
                </div>
              </div>
              <div v-else class="txt" @click="toQQ">请咨询订舱口或客服</div>
            </template>
          </WTable>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

export default {
  name: "Agent",
  props: {
    visible: Boolean,
    agentData: Array
  },
  data() {
    return {
      WTableOpts: {
        data: [],
        tableAttrs: { border: false },
        tableColAttrs: [
          { prop: 'carrier', label: '船公司'},
          { prop: 'shipName', label: '船名'},
          { prop: 'voyageNo', label: '航次'},
          { prop: '', slotName: 'agent', label: '参考船代'},
        ]
       
      },
      
    }
  },
  created() {
    console.log(this.agentData)
    this.WTableOpts.data = this.agentData
  },
  methods: {
    //选择此船代
    chooseAgent(shipAgent){
      this.$emit('chooseAgent',shipAgent)
      this.closeDialog();
    },
    // 复制
    copy(e){
      this.$copyText(e)
			this.$message({
				type: 'success',
				message: '复制成功!'
			})
    },
    // 联系客服
    toQQ(){
      window.open('https://wpa1.qq.com/yGWcFLfo?_type=wpa&qidian=true')
    },
    // 关闭
    closeDialog(){
      this.$emit('closeDialog')
    }
  }
}
</script>

<style scoped lang="less">
.agent-dialog {
  color: #333333;
  font-size: 14px;

  .el-button {
    height: 32px;
  }
  .icon-fuzhi {
    color: #1170eb;
    font-size: 12px;
    cursor: pointer;
    margin-left: 8px !important;
  }
  .txt {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ed6a0c;
    line-height: 20px;
    cursor: pointer;
  }
}
</style>